import styles from './styles.module.scss';

export default function MinimalistCard({ children, className = '' }) {
  return (
    <div className={`${styles.minimalistCard} ${className}`}>{children}</div>
  );
}
